import React from 'react';
import cx from 'classnames';
import styles from './EngageSidebar.module.scss';
import { Icon } from '../Icon';
import { CustomButton } from '../Button/Button';
import Popover from 'react-tiny-popover';

const SidebarExternalLink = ({ mini, text, link, newTab = false, allowAnimation }) => {
  const [hover, setHover] = React.useState(false);
  const handleClick = () => {
    if (newTab) {
      window.open(link, '_blank');
    } else {
      window.location.href = link;
    }
  };

  return (
    <Popover
      isOpen={mini && hover}
      position={['right']}
      content={<div className={styles.popoverContainer}>{text}</div>}
      containerStyle={{ zIndex: '999' }}
    >
      <div onMouseOver={() => setHover(true)} onMouseLeave={() => setHover(false)}>
        <CustomButton
          className={cx(styles.sidebarSection, styles.sidebarExternalLink, { [styles.mini]: mini }, { [styles.animate]: allowAnimation })}
          variant="link"
          onClick={handleClick}
          ariaLabel={mini && 'Open support page'}
        >
          <Icon className={styles.sidebarIcon} src="external_vormats" />
          {mini ? null : <span className={styles.name}>{text}</span>}
        </CustomButton>
      </div>
    </Popover>
  );
};

export default SidebarExternalLink;
